
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyThemeProvider as SkyThemeProviderElement, SkyThemeProviderGlobalChangeDetail } from '@sky.ui/core/sky-theme-provider';
 
 

 
 export const SkyThemeProvider = createComponent({
   displayName: 'SkyThemeProvider',
   react: React,
   tagName: 'sky-theme-provider',
   elementClass: SkyThemeProviderElement,
   events: {
     
     onThemeChangeGlobal: 'theme-change-global' as EventName<CustomEvent<SkyThemeProviderGlobalChangeDetail>>,
     onSkyTheme: 'sky-theme' as EventName<CustomEvent<SkyThemeProviderGlobalChangeDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-theme-provider';
